// Web Worker クライアント。tide.worker.ts と通信するヘルパー。

import type { Extremum } from '@tideprecision/shared';
import TideWorker from '../workers/tide.worker.ts?worker';

interface PendingRequest {
  resolve: (v: { levels: Float32Array; extrema: Extremum[] }) => void;
  reject: (e: Error) => void;
}

let worker: Worker | null = null;
let nextId = 1;
const pending = new Map<number, PendingRequest>();

function getWorker(): Worker {
  if (worker) return worker;
  worker = new TideWorker();
  worker.onmessage = (ev: MessageEvent<{ type: string; id: number; [k: string]: unknown }>) => {
    const data = ev.data;
    const p = pending.get(data.id);
    if (!p) return;
    pending.delete(data.id);
    if (data.type === 'compute_result') {
      p.resolve({
        levels: data.levels as unknown as Float32Array,
        extrema: data.extrema as unknown as Extremum[],
      });
    } else if (data.type === 'error') {
      p.reject(new Error(data.message as string));
    }
  };
  worker.onerror = (ev) => {
    // 全 pending を reject
    for (const [id, p] of pending) {
      p.reject(new Error(ev.message ?? 'worker error'));
      pending.delete(id);
    }
  };
  return worker;
}

export function computeTideInWorker(
  stationBlob: ArrayBuffer,
  epochSeconds: number,
): Promise<{ levels: Float32Array; extrema: Extremum[] }> {
  const w = getWorker();
  const id = nextId++;
  return new Promise((resolve, reject) => {
    pending.set(id, { resolve, reject });
    // 呼び出し側は新しい ArrayBuffer を都度確保する想定。Transferable で渡してコピー削減。
    w.postMessage({ type: 'compute', id, stationBlob, epochSeconds }, [stationBlob]);
  });
}
